// A lista de gatilhos "Use quando: a; b; c." — o formato em que as ferramentas nativas do
// runtime (pedir humano, atualizar o funil) recebem o QUANDO. O runtime só conhece texto; a
// tela é quem escreve a lista e quem a abre de volta.
//
// Saiu do HandoffForm.vue quando o diálogo do funil (CRM-03) passou a escrever o mesmo formato.
// Uma segunda cópia do parser seria o defeito que diverge calado: um lado passaria a gravar
// uma frase que o outro já não abre como lista.
//
// Texto nesse formato abre de volta como lista; qualquer outro (escrito antes da lista, ou pela
// API) abre como UM gatilho e, se ninguém mexer, volta gravado como estava.

export const CABECALHO_QUANDO = 'Use quando: ';

// "; " separa os gatilhos na frase, então não pode existir dentro de um: vira ", ". E o
// ponto final de cada um sai, porque a frase inteira ganha um só.
export function limparGatilho(texto) {
  return texto
    .trim()
    .replace(/;/g, ',')
    .replace(/[\s.,]+$/, '');
}

// `padrao` é o que aparece quando nada foi gravado: o handoff mostra os critérios do runtime
// como gatilhos editáveis; o funil não tem padrão e abre vazio.
export function gatilhosDoTexto(texto, padrao = []) {
  if (!texto) return padrao;
  if (!texto.startsWith(CABECALHO_QUANDO) || !texto.endsWith('.'))
    return [texto];
  return texto.slice(CABECALHO_QUANDO.length, -1).split('; ');
}

// Os gatilhos que vão para a API: limpos, sem vazio e sem repetição (a primeira ocorrência
// vence). Quem chama diz na tela o que caiu — ver `gatilhosRepetidos` e `temGatilhoVazio`.
export function gatilhosValidos(textos) {
  const vistos = new Set();
  return textos.map(limparGatilho).filter(texto => {
    if (!texto || vistos.has(texto)) return false;
    vistos.add(texto);
    return true;
  });
}

export function gatilhosRepetidos(textos) {
  const vistos = new Set();
  const repetidos = new Set();
  textos.forEach(bruto => {
    const texto = limparGatilho(bruto);
    if (!texto) return;
    if (vistos.has(texto)) repetidos.add(texto);
    else vistos.add(texto);
  });
  return [...repetidos];
}

export function temGatilhoVazio(textos) {
  return textos.some(texto => !limparGatilho(texto));
}

export const mesmaLista = (a, b) =>
  a.length === b.length && a.every((texto, i) => texto === b[i]);

// A frase que vai para a API. Lista igual à que abriu → o texto gravado, intacto (inclusive o
// que não estava no formato de lista). Vazia ou igual ao padrão → `null`, e o runtime segue
// com o critério dele.
export function quandoTexto(lista, { iniciais, gravado, padrao = [] }) {
  if (mesmaLista(lista, iniciais)) return gravado;
  if (!lista.length || mesmaLista(lista, padrao)) return null;
  return `${CABECALHO_QUANDO}${lista.join('; ')}.`;
}
